import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import { hex2rgba } from '~/utils/colorHelper';

export const CartItem: StyleRule = ({ theme }) => ({
    columnGap: theme.siteVariables.spaces['space-12'],
    padding: pxArrayToRem([12, 16]),
    maxWidth: pxToRem(382),
    alignItems: 'flex-start',
    '&:hover': {
        backgroundColor: hex2rgba(
            theme.siteVariables.colors.primitive.black,
            0.06,
        ),
    },
    [theme.screen.tablet]: {
        columnGap: theme.siteVariables.spaces['space-8'],
        alignItems: 'center',
    },
});

export const Image: StyleRule = ({ theme }) => ({
    width: pxToRem(64),
    height: pxToRem(64),
    '& img': {
        height: '100%',
        width: '100%',
    },
    [theme.screen.tablet]: {
        alignSelf: 'flex-start',
    },
});

export const ProductTitleContainer: StyleRule = () => ({
    minHeight: pxToRem(37),
});

export const ProductTitle: StyleRule = ({ theme }) => ({
    '&:not(:only-child)': {
        marginBottom: theme.siteVariables.spaces['space-4'],
    },
});

export const Pricing: StyleRule<{ isSample: boolean }> = ({
    theme,
    isSample,
}) => ({
    justifyContent: 'space-between',
    alignSelf: 'center',
    paddingBottom: isSample ? 0 : pxToRem(1),
    [theme.screen.tablet]: {
        marginTop: pxToRem(8.5),
    },
});

export const Price: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.grey['300'],
    lineHeight: pxToRem(18),
    fontSize: theme.siteVariables.fontSizes['caption04'],
    '& span': {
        display: 'inline',
    },
});

export const SampleTag: StyleRule = ({ theme }) => ({
    backgroundColor: theme.siteVariables.colors.grey['300'],
    lineHeight: pxToRem(15),
    letterSpacing: '0.08em',
    padding: pxArrayToRem([2, 4]),
    color: theme.siteVariables.colors.white['000'],
});

export const Quantity: StyleRule = ({ theme }) => ({
    lineHeight: pxToRem(18),
    justifyContent: 'center',
    width: '100%',
    alignSelf: 'center',
    [theme.screen.tablet]: {
        width: pxToRem(32),
    },
});

export const OptionLabel: StyleRule = () => ({
    lineHeight: pxToRem(18),
    marginBottom: pxToRem(5),
});

export const RetailPrice: StyleRule = ({ theme }) => ({
    textDecoration: 'line-through',
    color: theme.siteVariables.colors.grey[300],
    marginRight: theme.siteVariables.spaces['space-4'],
});

export const SalePrice: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.charcoal[250],
});
